@if (show) {
  <div
    class="waitron-page-loader"
    [class.waitron-page-loader--fullscreen]="fullscreen"
    [class.waitron-page-loader--inline]="!fullscreen"
    [class.waitron-page-loader--overlay]="overlay"
    role="status"
    aria-live="polite"
    aria-busy="true"
    >
    <div class="waitron-page-loader__card">
      <div class="waitron-page-loader__spinner" aria-hidden="true"></div>
      <p class="waitron-page-loader__message">{{ message }}</p>
    </div>
  </div>
}
